import { InformationCard, useIsMobile } from '@yes.technology/react-toolkit'

import { useIsOpen } from 'shared/hooks'
import {
  Container,
  Content,
  LeftImage,
  RightImage,
  Subtitle,
  Title
} from './HeroBannerSecondary.styles'
import { HeroBannerSecondaryProps } from './HeroBannerSecondary.types'
import HeroBannerSecondaryButton from './HeroBannerSecondaryButton'

const HeroBannerSecondary = ({
  des,
  complement,
  leftBackgroundImageUrl,
  rightBackgroundImageUrl,
  backgroundColor,
  textColor,
  button
}: HeroBannerSecondaryProps) => {
  const isMobile = useIsMobile()
  const { isOpen, open, close } = useIsOpen(false)

  return (
    <>
      <Container
        {...{
          backgroundColor
        }}
      >
        {!isMobile && <LeftImage {...{ leftBackgroundImageUrl }} />}

        <Content>
          <Title color={textColor}>{des}</Title>

          {isMobile ? (
            <HeroBannerSecondaryButton button={button} onClick={open} />
          ) : (
            <Subtitle color={textColor}>{complement}</Subtitle>
          )}
        </Content>

        {!isMobile && <RightImage {...{ rightBackgroundImageUrl }} />}
      </Container>

      {isMobile && (
        <InformationCard title={des as string} isOpen={isOpen} close={close}>
          {complement}
        </InformationCard>
      )}
    </>
  )
}

export default HeroBannerSecondary
